import json from "../json/jpdReadiness.json";

export default async () => JSON.parse(JSON.stringify(await json));
